module.exports = __webpack_public_path__ + "img/Solution1.bcaf0438.png";